const sectionsData = {
  trails: {
    tag: "Rotas",
    titlePrefix: "ALGUMAS DAS",
    titleAccent: "AVENTURAS",
    cards: [
      {
        id: "oliveira-campinhos",
        level: "Médio",
        levelClass: "level-medium",
        name: "Oliveira dos Campinhos",
        distance: "12.5 km",
        type: "Bate-volta",
        location: "Bahia",
        fallbackClass: "t1",
        backgroundImage: require("@/assets/oliveira-capa.jpeg"),
        backgroundPosition: "center"
      },
      {
        id: "muritiba",
        level: "Difícil",
        levelClass: "level-difficult",
        name: "Muritiba",
        distance: "5 km",
        type: "Bate-volta",
        location: "Bahia",
        fallbackClass: "t2",
        backgroundImage: require("@/assets/muritiba-capa.jpg"),
        backgroundPosition: "center"
      },
      {
        id: "caem",
        level: "Fácil",
        levelClass: "level-easy",
        name: "Caém",
        distance: "6 km",
        type: "Bate-volta",
        location: "Bahia",
        fallbackClass: "t3",
        backgroundImage: require("@/assets/caem-capa.jpeg"),
        backgroundPosition: "center"
      },
      {
        id: "itaitu",
        level: "Fácil",
        levelClass: "level-easy",
        name: "Itaitu Arapongas",
        distance: "3 km",
        type: "Bate-volta",
        location: "Bahia",
        fallbackClass: "t4",
        backgroundImage: require("@/assets/itaitu-capa.jpeg"),
        backgroundPosition: "center"
      },
      {
        id: "jacobina",
        level: "Avançado",
        levelClass: "level-hard",
        name: "Jacobina",
        distance: "8 km",
        type: "Bate-volta",
        location: "Bahia",
        fallbackClass: "t5",
        backgroundImage: require("@/assets/jacobina-capa.jpg"),
        backgroundPosition: "center"
      },
      {
        id: "mirangaba",
        level: "Médio",
        levelClass: "level-medium",
        name: "Mirangaba",
        distance: "11 km",
        type: "Bate-volta",
        location: "Bahia",
        fallbackClass: "t6",
        backgroundImage: require("@/assets/mirambaga-capa.jpg"),
        backgroundPosition: "center"
      }
    ]
  },
  testimonials: {
    tag: "Depoimentos",
    titlePrefix: "A ALCATEIA",
    titleAccent: "FALA",
    cards: [
      {
        id: 1,
        avatar: "SL",
        image: require("@/assets/fotos pessoas/sandra.jpg"),
        name: "Sandra Limah",
        trail: "sandralimah70",
        text:
          "Foi ótimo. A equipe, a organização, o transporte . A responsabilidade de todos os envolvidos \"os guias\". Equipe top demais. 🤩 Não poderia esquecer de nosso motorista, responsável, educado, top demais. 👏",
        delay: "0s"
      },
      {
        id: 2,
        avatar: "SD",
        image: require("@/assets/fotos pessoas/sarah.jpg"),
        name: "Sarah Demetrio",
        trail: "sarah_demetrioo",
        text:
          "Trilhar com WolfTrails para mim foi uma experiência única! Só tenho pontos positivos a citar. O cuidado do início ao fim, o acolhimento com todos, o profissionalismo, tudo isso proporciona confiança e vontade de querer ir mais e mais. Vocês são Fera! Quer dizer, Lobos 🐺!!!",
        delay: "0.15s"
      },
      {
        id: 3,
        avatar: "MM",
        image: require("@/assets/fotos pessoas/micael.jpg"),
        name: "Micael Muniz",
        trail: "micaelmz",
        text:
          "Às vezes a gente precisa se desligar um pouco da tecnologia e lembrar como é bom simplesmente estar na natureza. Fazer uma trilha com a Wolf Trails foi uma experiência que realmente marcou. Além de toda a organização, o mais legal é que você sempre acaba conhecendo gente nova e criando amizades pelo caminho.",
        delay: "0.3s"
      },
      {
        id: 4,
        avatar: "MA",
        image: require("@/assets/fotos pessoas/mateus.jpg"),
        name: "Mateus Araujo",
        trail: "teuzma_",
        text:
          "Parabéns a todo o grupo! Dá pra ver que tem união, respeito e muita paixão pela trilha. É muito bom ver pessoas que compartilham o mesmo espírito de aventura, sempre ajudando uns aos outros e curtindo cada momento. Que venham muitas trilhas, lama e histórias boas pela frente! 🧗🏻‍♂️🛤️🌿",
        delay: "0.45s"
      },
      {
        id: 5,
        avatar: "AS",
        image: require("@/assets/fotos pessoas/aline.jpg"),
        name: "Aline Silva",
        trail: "alinesilva9278",
        text:
          "Então… foi duas experiências incríveis!!! De intensidades e vivências diferentes. A equipe super competente e prestativa e além disso são pessoas carismáticas e divertidas e caba que fica um passeio ainda mais leve. Obrigado por cada experiência inesquecível que venha as próximas!!!🥰🥰🤗🤗",
        delay: "0.6s"
      },
      {
        id: 6,
        avatar: "RL",
        image: require("@/assets/fotos pessoas/raissa.jpg"),
        name: "Raíssa Lago",
        trail: "olaf_rai",
        text:
          "Tem sido show participar das trilhas, a equipe sempre muito atenciosa, cuidadosa e parceira. O astral das trilhas é cada vez melhor, e olha que pensar que eu sempre disse que não iria, não vejo a hora de ter oportunidade de ir para outra.",
        delay: "0.75s"
      },
    ]
  }
};

export default sectionsData;
